// extracted by mini-css-extract-plugin
module.exports = {"intro":"intro-module--intro--2_uwz","avatar":"intro-module--avatar--3eT5g"};